export const findThumbnail = providedId => {
  switch (providedId) {
    //Lifelique case
    case 'e_dialysis_cannulation':
    case 'e_nurse_stetoskop':
    case 'e_nurse_oximetr':
    case 'f_vyna_mikrometr':
    case 'f_vyna_sroubek_zoom':
    case 'f_vyna_elekrometr':
    case 'f_vyna_prutok_vody_v_potrubi':
    case 'f_vyna_kladkostroj':
    case 'f_vyna_zvedak':
    case 'f_vyna_pojistka':
    case 'f_vyna_bimetalovy_teplomer':
    case 'f_vyna_vysavac':
    case 'e_dialysis_fressenius_machine':
    case 'e_nurse_tlakomer':
    case 'e_dialysis_rope_ladder_buttonhole':
    case 'p_clov_zlomenina_kosti':
    case 'i_tech_spravne_sezeni_u_pc':
    case 'c_hemi_kys_acetylsalicova':
    case 'f_vyna_3d_tiskarna':
    case 'f_vyna_parni_stroj':
    case 'f_vyna_rele':
    case 'f_vyna_pc_celek':
    case 'f_vyna_polystyren_2_zoom':
    case 'p_zver_pstruh_duhovy':
    case 'p_zver_krava_zaludek':
    case 'p_rost_oves_klasek':
    case 'i_tech_zakladni_deska':
    case 'f_vyna_pc_opticky_kabel':
    case 'e_dialysis_artificial_kidney':
    case 'f_vyna_hyd_brzdy':
    case 'e_dialysis_hypertrophy':
    case 'e_dialysis_zdrava_nemocna_ledvina':
    case 'e_dialysis_acess_fistula':
    case 'e_dialysis_acess_graft':
    case 'e_dialysis_aneurysm':
    case 'e_dialysis_catheter':
    case 'e_dialysis_catheter_body':
    case 'e_dialysis_stenosis':
    case 'e_dialysis_avf_needle':
    case 'e_dialysis_butterfly_tape_technique':
    case 'e_dialysis_needle_sharpness':
    case 'e_dialysis_retrograde_antegrade_insertion':
    case 'e_dialysis_artificial_kidney_head':
    case 'e_dialysis_heparin_pump':
    case 'e_dialysis_perilstatic_pump':
    case 'e_dialysis_uo_detectors':
    case 'p_clov_obehovy_system':
    case 'p_clov_srdce':
    case 'e_nurse_skin_turgor':
    case 'p_clov_rez_kuzi':
    case 'e_nurse_teplomer':
    case 'p_clov_kloub_kolenni':
    case 'p_clov_stavba_kosterniho_svalu':
    case 'p_clov_stavba_kostry':
    case 'p_clov_svalova_soustava':
    case 'e_nurse_respiracni_system_dychani':
    case 'p_clov_dolni_cesty_dychaci':
    case 'p_clov_rez_horni_cesty_dychaci':
    case 'p_clov_rez_plicnim_sklipkem':
    case 'f_vyna_otvirak_na_pivo':
    case 'f_vyna_diferencial':
    case 'f_vyna_kondenzator':
    case 'f_vyna_civka_pohybujici_magnet':
    case 'f_vyna_transformator':
    case 'f_vyna_elektricky_odpor':
    case 'f_vyna_paralelni_zapojeni':
    case 'f_vyna_magnetizace_pomoci_civky':
    case 'f_vyna_seriove_zapojeni':
    case 'f_vyna_atmosfera':
    case 'f_vyna_pc_celek_vnitrek':
    case 'f_vyna_solarni_ohrev':
    case 'p_clov_travici_soustava':
    case 'p_clov_vylucovaci_soustava':
    case 'p_clov_nervova_soustava':
    case 'p_clov_mizni_soustava':
    case 'f_vyna_vetrna_elektrarna':
    case 'p_clov_organy':
    case 'p_clov_anatomie_animace':
    case 'p_clov_chutovy_poharek':
      return `/images/nevada/lifelique/${providedId}.png`
    case 'nevada_promotion':
      return '/js/app/svg/70afa99c1895f61f150d.svg'
    default:
      return null
  }
}
